import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { StarIcon, ArrowLeftIcon } from '../components/Icons';
import './NoticePage.css';

interface Notice {
  id: number;
  title: string;
  content: string;
  date: string;
  isImportant: boolean;
}

const NoticePage: React.FC = () => {
  // 하드코딩된 공지사항 데이터 (나중에 API로 대체 가능)
  const [notices] = useState<Notice[]>([
    {
      id: 1,
      title: 'Tripistocka 서비스 오픈 안내',
      content: `Tripistocka 서비스가 정식으로 오픈되었습니다. 
      
투자 기록을 체계적으로 관리하고 포트폴리오를 분석할 수 있는 다양한 기능을 제공합니다.

주요 기능:
- 투자 기록 관리 (매수/매도)
- 포트폴리오 분석
- 캘린더 뷰
- 자산 관리

많은 이용 부탁드립니다.`,
      date: '2024-12-01',
      isImportant: true
    },
    {
      id: 2,
      title: '자산 관리 기능 업데이트',
      content: `자산 관리 페이지에 새로운 기능이 추가되었습니다.

추가된 기능:
- 고정 수입/지출 관리
- 월별 자산 변화 추적
- 계산 시작 날짜 설정
- 실제 금액 입력 및 차이 계산

더욱 편리한 자산 관리를 경험해보세요.`,
      date: '2024-12-16',
      isImportant: false
    },
    {
      id: 3,
      title: '투자 주의사항 안내',
      content: `Tripistocka는 투자 기록을 관리하는 도구일 뿐, 투자 조언을 제공하지 않습니다.

모든 투자 결정은 본인의 판단과 책임 하에 이루어져야 하며, 
투자에 따른 손실은 본인에게 귀속됩니다.

투자는 신중하게 결정하시고, 본인의 투자 성향과 자금 상황을 고려하여 투자하시기 바랍니다.`,
      date: '2024-12-10',
      isImportant: true
    }
  ]);

  const [expandedNoticeId, setExpandedNoticeId] = useState<number | null>(null);

  const toggleNotice = (id: number) => {
    setExpandedNoticeId(expandedNoticeId === id ? null : id);
  };

  const formatDate = (dateString: string) => {
    const date = new Date(dateString);
    return date.toLocaleDateString('ko-KR', {
      year: 'numeric',
      month: 'long',
      day: 'numeric'
    });
  };

  return (
    <div className="notice-page">
      <div className="notice-container">
        <h1>공지사항</h1>
        <p className="notice-subtitle">Tripistocka의 주요 소식과 업데이트를 확인하세요</p>
        
        <div className="notices-list">
          {notices.map((notice) => (
            <div 
              key={notice.id} 
              className={`notice-item ${notice.isImportant ? 'important' : ''} ${expandedNoticeId === notice.id ? 'expanded' : ''}`}
            >
              <div 
                className="notice-header"
                onClick={() => toggleNotice(notice.id)}
              >
                <div className="notice-header-left">
                  {notice.isImportant && (
                    <span className="important-badge" title="중요">
                      <StarIcon size={16} color="currentColor" />
                    </span>
                  )}
                  <h3 className="notice-title">{notice.title}</h3>
                </div>
                <div className="notice-header-right">
                  <span className="notice-date">{formatDate(notice.date)}</span>
                  <span className="notice-toggle">
                    {expandedNoticeId === notice.id ? '▲' : '▼'}
                  </span>
                </div>
              </div>
              
              {expandedNoticeId === notice.id && (
                <div className="notice-content">
                  <div className="notice-content-text">
                    {notice.content.split('\n').map((line, index) => (
                      <p key={index}>{line || <br />}</p>
                    ))}
                  </div>
                </div>
              )}
            </div>
          ))}
        </div>

        {notices.length === 0 && (
          <div className="no-notices">
            <p>현재 공지사항이 없습니다.</p>
          </div>
        )}

        <div className="notice-footer">
          <Link to="/" className="back-link"><span style={{ display: 'inline-flex', alignItems: 'center', marginRight: '4px' }}><ArrowLeftIcon size={16} color="currentColor" /></span> 홈으로 돌아가기</Link>
        </div>
      </div>
    </div>
  );
};

export default NoticePage;

